import { Breadcrumb, Col, Row, Button } from "antd";
import ItemBillLists from "./ItemBillTable";
import { ScanOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { ScanToAdd } from "./scantoAdd";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import { getCategoryDrpdown } from "../../api/category";
import { getBill } from "../../api/bills";
import { Bill, Pagination } from "./Types";
interface Item {
  id: number;
  name: string;
  barcode: string;
  category: {
    id: number;
    name: string;
    description: string;
    isActive: boolean;
  };
  description: string;
  image: string | null;
  sku: string;
  isActive: boolean;
}

interface BillItem {
  id: number;
  item: Item;
  quantity: number;
  price: number;
  sales: number | null;
  lastPrice: number | null;
  lastSales: number | null;
  priceText: string;
  expirationDate: number;
  isTaxable: boolean;
  tax: number;
  discount: number;
  discountType: string | null;
  notes: string;
  isReturned: boolean;
  returnedQuantity: number;
}

interface Category {
  id: number;
  name: string;
  isActive: boolean;
}

const ItemBills = () => {
  const billId = useParams().billId;

  const [tableKey, setTableKey] = useState(0);

  const [openScan, setOpenScan] = useState(false);

  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");

  const [billItems, setBillItems] = useState<BillItem[]>();
  const [bill, setBill] = useState<Bill>()

  const [barcode, setBarcode] = useState<string>("");

  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const { state } = useLocation();
  const { disabled, invoiceNo } = state

  const [pagination, setPagination] = useState<Pagination>({
    current: 1,
    pageSize: 10,
    total: 0,
    limit: 10,
  });


  const { mutateAsync: getItemsBillMutation, isLoading: isItemBillLoading } =
    useMutation("billItems", ({ billId, q, limit, offset }: {
      billId: number, q?: string, limit?: number, offset?: number
    }) => getBill({ billId, q, limit, offset }), {
      onSuccess: ({ data }) => {
        setBillItems(data.data);
        setBill(data.bill)
        if (data.total !== pagination.total) {
          setPagination(prevPagination => ({
            ...prevPagination,
            total: data.total,
            current: 1
          }));
        }
      },
      onError: (res: any) => {
        window.alert(res ? res.data.message : "Error getting items in Bill")
      }
    });

  const { mutateAsync: getCatogoriesMutation } = useMutation(
    "getItems",
    getCategoryDrpdown
  );

  const resetFilters = () => {
    if (!search) return

    setTableKey((tableKey) => tableKey + 1);
    setSearch("");
    getItemsBillMutation({ billId: Number(billId), limit: pagination.limit, offset: (pagination.current - 1) * pagination.pageSize });
    setPagination(prevPagination => ({
      ...prevPagination,
      current: 1
    }))
  };

  const handleTableChange = (pagination: Pagination) => {
    setPagination(pagination);
    getItemsBillMutation({ billId: Number(billId), q: search, limit: pagination.limit, offset: (pagination.current - 1) * pagination.pageSize })
  };

  const handleAddItem = async () => {
    const res = await getCatogoriesMutation()
    const categories = res.data
      .filter((category: Category) => category.isActive)
      .map((category: Category) => {
        return { value: category.id, label: category.name };
      });
    navigate(`./create`, {
      state: {
        categories,
        bill
      },
    });
  };

  const handleScan = (barcodeString: string) => {
    if (barcodeString) {
      setBarcode(barcodeString);
    }
  };

  let barcodeScan = "";
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter" && barcodeScan.length > 3) {
        handleScan(barcodeScan);
        barcodeScan = "";
        return;
      }
      if (e.key === "Shift") {
        return;
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      barcodeScan += e.key;
      setTimeout(() => {
        barcodeScan = "";
      }, 150);
    };

    document.addEventListener("keydown", handleKeyDown);

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  },[]);

  useEffect(() => {
    barcode && setOpenScan(true);
  }, [barcode]);

  // initial load
  useEffect(() => {
    getItemsBillMutation({ billId: Number(billId), q: search, limit: pagination.limit, offset: (pagination.current - 1) * pagination.pageSize })
  }, []);

  const handleDeleteRefresh = () => {
    getItemsBillMutation({ billId: Number(billId), q: search, limit: pagination.limit, offset: (pagination.current - 1) * pagination.pageSize })
  }

  return (
    <>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Col offset={1} span={22}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              { title: <Link to="/bills">{t("bills-list")}</Link> },
              {
                title: (
                  <span className="breadcrumbcolor">{t("items-bills")}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col
          offset={1}
          span={22}
          style={{ fontSize: "32px", color: "#162149", fontWeight: "600px" }}
        >
          {invoiceNo}
        </Col>
        <Col offset={1} span={4} style={{ marginTop: "10px" }}>
          <Search
            value={search}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setSearch(e.target.value);
            }}
            onEnter={() => {
              getItemsBillMutation({ billId: Number(billId), q: search, limit: pagination.limit, offset: (pagination.current - 1) * pagination.pageSize })
            }}
          />
        </Col>
        <Col
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
          span={2}
          offset={16}
        >
          <Col style={{ textAlign: 'center', color: disabled ? 'gray' : '' }}>
            <Button
              className="Button"
              type="text"
              onClick={() => {
                setOpenScan(true);
              }}
              disabled={disabled}
              icon={<ScanOutlined style={{ fontSize: "22px" }} />}
            />
            {t("scan")}
          </Col>
          {/* <Col style={{ textAlign: 'center' }}>
            <Button
              style={{ width: "3rem" }}
              className="Button"
              type="text"
              icon={<RedoOutlined style={{ fontSize: "22px" }} />}
            />{" "}
            {t("return")}
          </Col> */}
          <Col style={{ marginTop: "10px" }}>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <Col style={{ marginTop: "10px" }}>
            <AddButton onClick={() => handleAddItem()} disabled={disabled} />
          </Col>
        </Col>
        <Col offset={1} span={22}>
          <ItemBillLists
            bill={bill}
            billItems={billItems}
            handleDeleteRefresh={handleDeleteRefresh}
            tableKey={tableKey}
            searchText={searchText}
            setSearchText={setSearchText}
            isItemBillLoading={isItemBillLoading}
            handleTableChange={handleTableChange}
            pagination={pagination}
            disabled={disabled}
            invoiceNo={invoiceNo}
          />
        </Col>
        <Col
          offset={1}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <CancelBtn />
        </Col>
      </Row>
      <ScanToAdd
        openScan={openScan}
        setOpenScan={setOpenScan}
        billId={billId}
        handleTableChange={handleTableChange}
        pagination={pagination}
      />
    </>
  );
};

export default ItemBills;
